export default __webpack_public_path__ + "static/media/koffingTexShiny.e5ddbd70.jpg";